export const useRedirectAfterSignup = () => ({
    setRedirectUrlAfterSignup: (path: string) => sessionStorage.setItem('redirectUrlAfterSignup', path),
    getRedirectUrlAfterSignup: () => sessionStorage.getItem('redirectUrlAfterSignup'),
    clearRedirectUrlAfterSignup: () => sessionStorage.removeItem('redirectUrlAfterSignup'),
});
